import Headers from "../components/Header";
import Backbutton from "../components/Backbutton";
import Registerpage from "../components/register/Registerpage";
function Register() {

    return (
        <>
            <Headers />
            <Backbutton />
            <Registerpage />
        </>
    );
}

export default Register;
